module.exports = __webpack_public_path__ + "assets/purple_background_mobile.fbb4020ebe125f05095147396614b24e.jpg";